module.exports = __webpack_public_path__ + "static/media/in_a_week_11.e3b9eb96.jpg";